import { setDisplayName } from 'recompose';
import styled from 'styled-components';
import { Sans } from './core';
/**
 * This is for short paragraphs with no more than four lines and is commonly
 * used in components.
 */ export const BodyShort01 = setDisplayName('BodyShort01')(styled(Sans)`
  font-size: 0.875rem;
  line-height: 1.125rem;
  font-weight: 400;
`);
/**
 * This is commonly used in both the expressive and the productive type theme
 * layouts for long paragraphs with more than four lines. It is a good size for
 * comfortable, long-form reading. Use this for longer body copy in components
 * such as accordion or structured list. Always left-align this type; never
 * center it.
 */ export const BodyLong01 = setDisplayName('BodyLong01')(styled(BodyShort01)`
  line-height: 1.25rem;
`);
/**
 * This is for short paragraphs with no more than four lines and is commonly
 * used in the expressive type theme for layouts.
 */ export const BodyShort02 = setDisplayName('BodyShort02')(styled(Sans)`
  font-size: 1rem;
  line-height: 1.375rem;
  font-weight: 400;
`);
/**
 * This is commonly used in the expressive type theme layouts for long
 * paragraphs with more than four lines. The looser line height and larger size
 * makes for comfortable, long-form reading, in mediums that allow for more
 * space. This size type is rarely used for body copy in components. Always
 * left-align type; never center it.
 */ export const BodyLong02 = setDisplayName('BodyLong02')(styled(BodyShort02)`
  line-height: 1.5rem;
`);
